<template>
  <div class="public-content balance-enquiry">
    <div class="breadcrumb">余额交易审核</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="100px" class="demo-form-inline">
        <el-row>
          <el-col :span="6" v-if="type !== 0">
            <el-form-item label="业务:">
              <el-select clearable v-model="formInline.salesmanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
                <el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台名称:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterByName" filterable placeholder="请输入平台名称">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="状态:">
              <el-input v-model="formInline.serialNo" placeholder="请输入平台名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="交易方式:">
              <el-select v-model="formInline.tradeMethod" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option label="线上充值" value="CHARGE_ONLINE"></el-option>
                <el-option label="离线充值" value="CHARGE_OFFLINE"></el-option>
                <el-option label="负责订单取消" value="CHARGE_ORDER_CANCELLED"></el-option>
                <el-option label="负责退款良好" value="CHARGE_REFUND_POSTSALE"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="交易类型:">
              <el-select v-model="formInline.tradeType" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option label="消费" value="TRADE"></el-option>
                <el-option label="充值" value="CHARGE"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支付日期:" class="el-date-width">
              <el-date-picker clearable v-model="value2" type="daterange" align="left" unlink-panels range-separator="至" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, onSubmit()" round>查询</el-button>
            <el-button class="search-ok" @click="exportExcel" round v-if="type !== 0">导出Excel</el-button>
            <el-button type="primary" round>申请充值</el-button>
            <el-button type="primary" style="min-width:110px!important;" round>申请余额交易</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" :row-class-name="rowClassName" border style="width: 100%">
          <el-table-column label="订单号" fixed="left" min-width="220">
            <template v-slot="scope">
              <span class="color-blue" @click="goPage">{{ scope.row.outOrderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="platformNum" label="平台号" min-width="180">
            <template slot-scope="scope"> {{ scope.row.account ? scope.row.account.store ? scope.row.account.store.code : '' : '' }} </template>
          </el-table-column>
          <el-table-column prop="platformName" label="平台名称" min-width="180">
            <template slot-scope="scope"> {{ scope.row.account ? scope.row.account.store ? scope.row.account.store.name : '' : '' }} </template>
          </el-table-column>
          <el-table-column label="业务" min-width="180">
            <template slot-scope="scope"> {{ scope.row.account ? scope.row.account.store ? scope.row.account.store.salesman ? scope.row.account.store.salesman.userName : '' : '' : '' }} </template>
          </el-table-column>
          <el-table-column prop="amount" label="交易金额" min-width="180"></el-table-column>
          <el-table-column prop="amount" label="交易虚拟充值" min-width="180"></el-table-column>
          <el-table-column label="交易类型" min-width="180">
            <template slot-scope="scope"> {{ scope.row.tradeType === 'TRADE' ? '交易' : scope.row.tradeType === 'REFUND' ? '退款' : scope.row.tradeType === 'CHARGE' ? '充值' : '未定义' }} </template>
          </el-table-column>
          <el-table-column label="交易方式" min-width="180">
            <template slot-scope="scope"> {{ scope.row.paymentType === 'VPAY' ? '余额支付' : scope.row.paymentType === 'PAY_QRCODE' ? '扫码支付' : scope.row.paymentType === 'UNIONPAY' ? '银联' :
              scope.row.paymentType === 'GIFT' ? '礼品卡' : scope.row.paymentType === 'WXPAY' ? '微信支付' : scope.row.paymentType === 'ALIPAY' ? '支付宝' : scope.row.paymentType === 'BONUS' ? '虚拟充值' :
                scope.row.paymentType === 'OFFLINE' ? '线下' : '未定义' }} </template>
          </el-table-column>
          <el-table-column prop="plateformPrice" label="支付日期" min-width="180">
            <template slot-scope="scope"> {{ scope.row.paymentDate.substring(0, scope.row.paymentDate.indexOf('T')) }} </template>
          </el-table-column>
          <el-table-column prop="plateformPrice" label="审核日期" min-width="180">
            <template slot-scope="scope"> {{ scope.row.paymentDate.substring(0, scope.row.paymentDate.indexOf('T')) }} </template>
          </el-table-column>
          <el-table-column prop="amount" label="备注" min-width="180"></el-table-column>
          <el-table-column prop="amount" fixed="right" label="状态" min-width="180"></el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" @changePage="changePage" :queryInfo='queryInfo'></v-pagination>
    </div>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import store from '@/store'
import { orderPage, orderExport } from '@/api/epay'
import { storeQueryListByCode, getSalesmanByFullName, storeQueryListByName } from '@/api/crm'
export default {
  name: 'VpayChargeAudit',
  components: {
    VPagination
  },
  inject: ['reload'],
  data () {
    return {
      storeListByCode: [],
      storeListByName: [],
      salemanList: [],
      queryInfo: {
        total: 0,
        pageNum: 0,
        pageSize: 10
      },
      formInline: {
        dateEnd: '',
        dateStart: '',
        outOrderNo: '',
        salesmanId: '',
        serialNo: '',
        storeId: '',
        tradeMethod: '',
        tradeType: ''
      },
      tableData: [],
      type: store.state.systemType,
      value2: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      gridData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海'
      }],
      code: ''
    }
  },
  watch: {
    value2 () {
      this.formInline.dateStart = this.$moment(this.value2[0]).format('YYYY-MM-DD')
      this.formInline.dateEnd = this.$moment(this.value2[1]).format('YYYY-MM-DD')
    }
  },
  created () {
    this.onSubmit()
  },
  methods: {
    selectSalemanList (val) {
      if (val.trim()) {
        getSalesmanByFullName(val).then(res => {
          if (res.data.success) {
            this.salemanList = res.data.data
          }
        })
      }
    },
    filterByName (val) {
      if (val.trim()) {
        storeQueryListByName(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    onSubmit () {
      // 向后台发送post请求,获取查询数据存储在tableData
      orderPage({ data: this.formInline, params: { page: this.queryInfo.pageNum, size: this.queryInfo.pageSize } }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data.content.map(a => {
            if (a.account?.store?.salesman) {
              a.account.store.salesman.userName = this.$msg.filterBridal(a.account?.store?.salesman.userName)
            }
            return a
          })
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    goPage () {
      this.$router.push({
        path: './epay/vpayChargeDetail',
        query: {
          id: 1
        }
      })
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      orderExport(this.formInline).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          // let _fileName = '当前余额明细表' + this.$moment(new Date()).format('YYMMDDhmmss') + '.xls'
          let _fileName = '当前余额明细表' + this.formInline.dateStart + '-' + this.formInline.dateEnd + '.xls'
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    handleSelect (item) {
      this.formInline.storeId = item.id
    },
    querySearchAsync (queryString, cb) {
      storeQueryListByCode(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";
</style>
